import { useContext } from "react";
import logo from "../../../assests/AGP_Logo.png";
import logoIsaga from "../../../assests/isaga-3.png";
import CountryDropdown from "../../../components/CountryDropdown";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import { Context as ContextAuth } from "../../../context/AuthContext";
import "./styles.css"
import Context from "../../../context/Context";
import { Link } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export const NavbarTemplate = () => {

  const nro_matricula = JSON.parse(localStorage.getItem('user'))
  const userSAPMatricula = nro_matricula['user_SAPMatricula'];
  const userMatricula = nro_matricula['user_Matricula'];
  const userName = nro_matricula['user_UserName'];

  const { handleLogout } = useContext(ContextAuth);
  const { displayMenu } = useContext(Context);

  function showWidth() {
    var innerWidth = window.innerWidth;
    var outerWidth = window.outerWidth;
    alert("Inner Width: " + innerWidth + " pixels\nOuter Width: " + outerWidth + " pixels");
  }

  return (
    // <header className=" navbar2">
    //   <div className="d-flex align-items-center">
    //     <Link to='/Dashboard'>
    //       <div className="logo-isaga">
    //         <img
    //           className="logo d-none d-sm-block align-items-center"
    //           src={logoIsaga}
    //         />
    //         {/* <img src={logoIsaga} className={`logo d-block d-sm-none w-25 ${displayMenu == 'none' ? '' : 'open'}`} /> */}
    //       </div>
    //     </Link>

    //     {/* <img src={logo} className="logo-agp d-none d-sm-block" onDoubleClick={showWidth} /> */}

    //     <AccountCircleIcon fontSize="large" className="ms-4 me-2" />
    //     <div className="d-block me-3 p-0">
    //       {/* {userName && (
    //         <p className="m-0 font-size-p-navbar">Usuário: {userName}</p>
    //       )} */}
    //       {userMatricula && (

    //         <p className="m-0 font-size-p-navbar">Matrícula: {userMatricula}</p>
    //       )}
    //       {userSAPMatricula && (
    //         <p className="m-0 font-size-p-navbar">Matrícula SAP: {userSAPMatricula}</p>
    //       )}
    //     </div>

    //     <div className="mx-5">
    //       <CountryDropdown className="countryes" />
    //     </div>

    //     <IconButton size="large" className="" onClick={handleLogout}>
    //       <LogoutIcon />
    //     </IconButton>

    //   </div>
    // </header>

    <header className="navbar2 d-flex align-items-center">
      <Link to='/Dashboard'>
        <img
          className="logo"
          src={logoIsaga}
        />
      </Link>

      <div className="d-flex align-items-center ms-auto mx-3">
        <AccountCircleIcon
          onDoubleClick={showWidth} fontSize="large" className="ms-4 me-2" />
        <div className="d-block">
          {userMatricula && (
            <p className="m-0">Matrícula: {userMatricula}</p>
          )}
          {userSAPMatricula && (
            <p className="m-0">Matrícula SAP: {userSAPMatricula}</p>
          )}
        </div>
      </div>
      <div className="mx-3">
        <CountryDropdown className="countryes" />
      </div>
      <IconButton size="large" className="ms-3" onClick={handleLogout}>
        <LogoutIcon />
      </IconButton>
    </header>

  );
}
